module.exports = __webpack_public_path__ + "img/category-bio.0b7e0410.svg";